import './App.css'
import logo from './assets/images/transpa.png'
import { useEffect, useState } from 'react'
import { useDebounce } from 'use-debounce'

let baseUrl = 'https://api.jikan.moe/v3/search/anime'

function App() {
  const [field, setField] = useState('')
  const [film, setFilms] = useState([])
  const [pending, setPending] = useState(false)
  const [query] = useDebounce(field, 100)

  useEffect(() => {
    async function searchNow() {
      try {
        if (field.length == 0) {
          console.log('Waiting for input...')
        } else {
          setPending(true)
          const response = await window.fetch(`${baseUrl}?q=${query}`)
          if(response.status == 404){
            console.log('No anime found...')
          }
          const data = await response.json()
          setFilms(data.results)
          setPending(false)
        }
      } catch (e) {
        setPending(false)
        console.log(e)
      }
    }
    searchNow()
  }, [query])

  return (
    <div className="App">
      <div>
        <img src={logo} alt="anime-search-logo" className="logo" />
      </div>
      <div className="form-wrapper">
        <input
          type="text"
          placeholder="search here..."
          value={field}
          onChange={(e) => setField(e.target.value)}
        />
        <button>submit</button>
      </div>
      <div className="container-search">
        {pending && <div>pending...</div>}
        {!pending &&
          film &&
          film.map((film) => (
            <div className="available-card" key={film.mal_id}>
              <img src={film.image_url} alt={film.title} className="image" />
              <div className="available-detail">
                <h3>{film.title}</h3>
                <p>{film.synopsis}</p>
              </div>
            </div>
          ))}
      </div>
    </div>
  )
}

export default App
